import { render, staticRenderFns } from "./_concerns_comments.vue?vue&type=template&id=46cde31f&lang=pug"
import script from "./_concerns_comments.vue?vue&type=script&lang=js"
export * from "./_concerns_comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports